import React from 'react';
import { Col, Card, CardTitle, CardBody, FormGroup, Button } from 'reactstrap';
import { useForm } from 'react-hook-form';

const Webservice = () => {
  const { register, handleSubmit } = useForm();
  const onSubmit = (form) => {
    // TODO: not yet implemented — this Settings form's Save is currently a no-op.
    console.log('### form ###', form);
  };
  return (
    <Card>
      <CardBody>
        <CardTitle>Webservice Connection</CardTitle>
        <form onSubmit={handleSubmit(onSubmit)} className="form-horizontal">
          <FormGroup row>
            <Col md="1">
              <label htmlFor="protocol">Protocol</label>
            </Col>
            <Col md="3">
              <select {...register('protocol')} className="form-control">
                <option value="https">https</option>
                <option value="http">http</option>
              </select>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col md="1">
              <label htmlFor="domain">Domain</label>
            </Col>
            <Col md="6">
              <input {...register('domain')} type="text" className="form-control" placeholder="domain.co.nz" />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col md="1">
              <label htmlFor="port">Port</label>
            </Col>
            <Col md="3">
              <input {...register('port')} type="text" className="form-control" placeholder="port" />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col md="1">
              <label htmlFor="path">Path</label>
            </Col>
            <Col md="6">
              <input {...register('path')} type="text" className="form-control" placeholder="sync-client" />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col md="1">
              <label htmlFor="poolId">Pool Id</label>
            </Col>
            <Col md="3">
              <input {...register('poolId')} type="text" className="form-control" placeholder="Web Service Pool id" />
            </Col>
          </FormGroup>
          <div className="float-end">
            <Button type="submit" color="primary">
              Save
            </Button>
          </div>
        </form>
      </CardBody>
    </Card>
  );
};

export default Webservice;
